import { HashRouter, Routes, Route, useParams } from 'react-router-dom'
import { Suspense, lazy, useEffect } from 'react'

import { getWikiRouteTitle } from './utils/routeTitle'

const gamePages = import.meta.glob('./games/*/pages/*.tsx') as Record<
  string,
  () => Promise<{ default: React.ComponentType }>
>

function capitalize(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const lazyCache = new Map<string, React.LazyExoticComponent<React.ComponentType>>()

function getLazyPage(modulePath: string, loader: () => Promise<{ default: React.ComponentType }>) {
  if (!lazyCache.has(modulePath)) {
    lazyCache.set(modulePath, lazy(loader))
  }
  return lazyCache.get(modulePath)!
}

function GameRouter() {
  const gameId = 'crimson-desert'
  const { page = 'wiki' } = useParams()
  const title = getWikiRouteTitle(page)

  const pageName = capitalize(page)
  const modulePath = `./games/${gameId}/pages/${pageName}Page.tsx`
  const loader = gamePages[modulePath]

  useEffect(() => {
    document.title = title
  }, [title])

  if (!loader) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-lg text-gray-500">页面不存在</p>
      </div>
    )
  }

  const PageComponent = getLazyPage(modulePath, loader)

  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-[var(--wiki-bg)]">
          <p className="text-[var(--wiki-text)] opacity-60">加载中...</p>
        </div>
      }
    >
      <PageComponent />
    </Suspense>
  )
}

export function AppRouter() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<GameRouter />} />
        <Route path="/:page" element={<GameRouter />} />
        <Route path="/:page/:id" element={<GameRouter />} />
        <Route path="/:page/:id/:itemId" element={<GameRouter />} />
      </Routes>
    </HashRouter>
  )
}
